import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './ModalConfirmation.Module.css';
import PaymentButton from '../../paymentButton/PaymentButton';
function ModalConfirmation({ show, title, message, onConfirm, onCancel, idCompra }) {

	return (
		<Modal className='containerConfirmation' show={show} onHide={onCancel} centered>
			<Modal.Header className='headerModalConfirmation' closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body className='modalConfirmationContainer'>
				{message}
				<div className='divMagico py-2'>
					<Button className='buttonSecondary' variant='secondary' onClick={onCancel}>
						Cancelar
					</Button>
					<Button className='botonModalConfirmacion' variant='primary' onClick={onConfirm}>
						Confirmar
					</Button>
				</div>
				
					{/* <PaymentButton compraId={idCompra}/> */}
			
			</Modal.Body>
		</Modal>
	);
}

export default ModalConfirmation;
